import { create } from 'zustand';

interface TimerState {
  isRunning: boolean;
  missionId: string | null;
  missionTitle: string | null;
  startedAt: Date | null;
  elapsed: number; // seconds
  description: string;
  start: (missionId: string, missionTitle: string, description?: string) => void;
  pause: () => void;
  resume: () => void;
  stop: () => { hours: number; missionId: string } | null;
  tick: () => void;
  setDescription: (desc: string) => void;
}

export const useTimerStore = create<TimerState>((set, get) => ({
  isRunning: false,
  missionId: null,
  missionTitle: null,
  startedAt: null,
  elapsed: 0,
  description: '',

  start: (missionId, missionTitle, description = '') => {
    set({ isRunning: true, missionId, missionTitle, startedAt: new Date(), elapsed: 0, description });
  },

  pause: () => {
    const { startedAt, elapsed } = get();
    if (startedAt) {
      const additional = Math.floor((Date.now() - startedAt.getTime()) / 1000);
      set({ isRunning: false, elapsed: elapsed + additional, startedAt: null });
    }
  },

  resume: () => {
    set({ isRunning: true, startedAt: new Date() });
  },

  stop: () => {
    const { missionId, startedAt, elapsed, isRunning } = get();
    if (!missionId) return null;

    const additional = isRunning && startedAt
      ? Math.floor((Date.now() - startedAt.getTime()) / 1000)
      : 0;
    const totalSeconds = elapsed + additional;
    const hours = Math.round((totalSeconds / 3600) * 100) / 100;

    set({ isRunning: false, missionId: null, missionTitle: null, startedAt: null, elapsed: 0, description: '' });
    return { hours, missionId };
  },

  tick: () => {
    const { isRunning, startedAt, elapsed } = get();
    if (!isRunning || !startedAt) return;
    const additional = Math.floor((Date.now() - startedAt.getTime()) / 1000);
    set({ elapsed: elapsed + additional, startedAt: new Date() });
  },

  setDescription: (description) => set({ description }),
}));
